export default __webpack_public_path__ + "static/assistant-502d4d7e0fd9396ae3fdf451c7e73064.jpg";